import React from "react"
import r1 from "../../images/new-landing/r1.svg"
import r2 from "../../images/new-landing/r2.svg"
import r3 from "../../images/new-landing/r3.svg"
import r4 from "../../images/new-landing/r4.svg"

export default function Accolades() {
  return (
    <section className="recieve pt-8 sm:pt-16 mb-6 sm:mb-16">
      <div className="container">
        <h2 className="capitalize text-xl sm:text-2xl leading-7 text-brand">
          Noteworthy awards and recognition
        </h2>
        <div className="flex flex-col sm:flex-row justify-around items-center mt-5 sm:mt-12 ">
          <div className='sm:mt-0 mt-3'>
            <div className="logo2 flex flex-col justify-center items-center">
              <img src={r1} alt="r1" />
            </div>

            <div className="desc hidden sm:block">
              2019 ‘Accountancy Software of the Year’ Finalist
            </div>
          </div>
          <div className="mt-12 sm:mt-0">
            <div className="logo2 flex flex-col justify-center items-center">
              <img src={r2} alt="r2" />
            </div>

            <div className="desc hidden sm:block">
              2020 Global Winner for the JUMPSTARTER Pitch Competition
            </div>
          </div>
          <div className="mt-12 sm:mt-0">
            <div className="logo2 flex flex-col justify-center items-center">
              <img src={r3} alt="r3" />
            </div>
            <div className="desc hidden sm:block">
              Member of MAP community (Australia’s leading start up program)
            </div>
          </div>
          <div className="mt-12 sm:mt-0">
            <div className="logo2 flex flex-col justify-center items-center">
              <img src={r4} alt="r4" />
            </div>
            <div className="desc hidden sm:block">
              2020 Australia Fintech Awards Finalist
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
